/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import {Button, Col, Panel, Row} from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, propTypes, reduxForm } from 'redux-form';
import { remove as removeAction, save as saveAction } from '../../../../reducers/equipment/equipment.actions';
import { load } from '../../../../reducers/equipmentCategory/equipmentCategory.actions';
import { isLocal } from '../../../../reducers/localId/localId';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import UnsavedChangesPrompt from '../../../UnsavedChangesPrompt/UnsavedChangesPrompt';
import './EquipmentForm.css';
import { equipmentCategories } from '../../../../reducers/equipmentCategory/equipmentCategory.reducer';
import SelectFormGroup from '../../../Forms/SelectFormGroup/SelectFormGroup';

export class EquipmentForm extends React.Component {
  constructor() {
    super();
    this.state = {
      showFields: false,
    };
  }

  componentDidMount() {
    this.props.loadCategories();
  }

  render() {
    // eslint-disable-next-line object-curly-newline
    const { submitting, dirty, remove, save, initialize, categories, handleSubmit, equipment: { name, removing, id } } = this.props;
    return (
      <span>
        {dirty && <UnsavedChangesPrompt dirty/>}

        <Row style={{'margin-top': "-14px"}}>
          <Col md={1}><Button style={{'height': "14px", "padding": "5px 15px 20px 15px", "font-size": "14px"}} onClick={() => this.setState({showFields: !this.state.showFields})}>Edit</Button></Col>
          <Col md={11} style={{'font-size': "14px"}}>{name}</Col>
        </Row>

        <Panel>
        {(this.state.showFields || id.toString().includes('LOCAL')) &&
        <Form
          onSubmit={
            handleSubmit(values =>
              save(values, id)
                .then(equipment => initialize(equipment.response)))}
        >
          <Row>
            <Col md={4}>
              <Field
                component={TTFormGroup}
                name="name"
                label="Name"
                type="text"
                required
              />
            </Col>
            <Col md={6}>
              <Field
                component={SelectFormGroup}
                name="equipment_category_id"
                label="Category"
                options={categories}
                required
              />
            </Col>
            <Col md={4}>
              <Field
                component={SelectFormGroup}
                name="hide"
                label="Hide Equipment?"
                options={[
                  {id: false, name: 'No'},
                  {id: true, name: 'Yes'},
                ]}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={2}>
              <SpinnerButton
                isLoading={submitting}
                type="submit"
                dirty={dirty}
              >
                {isLocal(id) ? 'Add' : 'Save'}
              </SpinnerButton>
            </Col>
            <Col xs={6} md={2}>
              <SpinnerButton
                isLoading={removing}
                onClick={() => remove(id)}
                bsStyle="danger"
              >
                Remove
              </SpinnerButton>
            </Col>
          </Row>
        </Form>
        }
        </Panel>
      </span>);
  }
}

EquipmentForm.propTypes = {
  ...propTypes,
  equipment: PropTypes.shape({
    isRemoving: PropTypes.bool.isRequired,
  }).isRequired,
  equipmentCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadCategories: PropTypes.func.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.equipment,
  form: `equipment${ownProps.equipment.id}`,
  categories: equipmentCategories(state),
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  save: (values, id) => dispatch(saveAction({ ...values, id })),
  loadCategories: () => dispatch(load()),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ enableReinitialize: true })(EquipmentForm));



// WEBPACK FOOTER //
// ./src/components/Admin/Equipment/EquipmentForm/EquipmentForm.jsx